import { useUserDetailProfile } from './hooks';
import { convertToPresentationProps } from './logics';
import { UserDetailProfilePresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者詳細プロフィール Container コンポーネント
 * API から取得した利用者情報をプロフィールとして表示する
 */
export const UserDetailProfile: React.FC<Props> = ({ userId }) => {
  const {
    state: { data },
  } = useUserDetailProfile({ userId });

  const {
    fullName,
    email,
    branchName,
    branchCode,
    billableFromLabel,
    createdAtLabel,
    updatedAtLabel,
    editLink,
  } = convertToPresentationProps({ data, userId });

  return (
    <UserDetailProfilePresentation
      fullName={fullName}
      email={email}
      branchName={branchName}
      branchCode={branchCode}
      billableFromLabel={billableFromLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
      editLink={editLink}
    />
  );
};
